import { useMutation, useQuery } from 'react-query';
import { request } from '../utils/axios-utils';

export const useGetStats = (date, sessionType, autoReload = false) =>
    useQuery(['shootSessionStats', date, sessionType], () => GetStats(date, sessionType), {
        refetchOnWindowFocus: false,
        refetchIntervalInBackground: autoReload,
        refetchInterval: autoReload ? 30000 : false,
        cacheTime: 0,
    });

const GetStats = async (date, sessionType) => {
    const { data } = await request({
        method: 'GET',
        url: `/warehouse/session/stats?date=${!!date ? date : new Date().toISOString()}&sessionType=${sessionType}`,
    });
    return data;
};

const GetSessionUsers = async (date, sessionType) => {
    const { data } = await request({
        method: 'GET',
        url: `/warehouse/session/piiUsers?date=${encodeURIComponent(date || new Date().toISOString())}&sessionType=${encodeURIComponent(sessionType)}`,
    });
    return data;
};

export const useGetSessionUsers = () =>
    useMutation({
        mutationFn: async ([date, sessionType]) => GetSessionUsers(date, sessionType),
    });
